import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import classNames from 'classnames';
import * as actions from '../../../actions/response';
import { converter } from '../../../helpers/converter';

const classButtonInactive = 'btn btn-default close-modal btn-block';

class ModalErrorResetPassword extends React.Component {
  static propTypes = {
    btnLabel: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal(cb) {
    this.props.closeModal('SuccessResetPassword');
    cb && cb(this);
  }

  onAccept(e, cb) {
    e.preventDefault();
    if (!cb) return this.closeModal();
    const scope = this;
    return cb(scope);
  }

  render() {
    const customIconClass = this.props.iconClass ? this.props.iconClass : false;
    const { btnLabel } = this.props;

    const classes = {
      fa: true,
      'text-center': true,
      'fa-3x': true,
      'fa-times': !customIconClass,
    };

    const titleStyle = {
      paddingTop: '14px',
      height: '48px',
      fontFamily: 'Arial',
      fontSize: '20px',
      fontWeight: 'bold',
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: '1.2',
      letterSpacing: 'normal',
      textAlign: 'center',
      color: '#f2f2f2',
    };

    const paragraphStyle = {
      fontFamily: 'Arial',
      fontSize: '14px',
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: '1.21',
      letterSpacing: 'normal',
      textAlign: 'center',
      color: '#f2f2f2',
    };

    if (customIconClass) {
      classes[customIconClass] = customIconClass;
    }

    const classesForBody = classNames(classes);

    return (
      <Modal show>
        <Modal.Header>
          <Button
            className="close close-modal"
            onClick={() => this.closeModal(this.props.onClose)}
          >
            x
          </Button>
        </Modal.Header>
        <Modal.Body className="modal-body text-center success">
          <i className={classesForBody} />
          <h4 style={titleStyle}>{this.props.title}</h4>
          <p
            style={paragraphStyle}
            dangerouslySetInnerHTML={{ __html: this.props.message }}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="footer-modal-button flex-end">
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 padding-top-05">
              <Button
                className={classButtonInactive}
                onClick={e => this.onAccept(e, this.props.onAccept)}
              >
                {btnLabel ||
                  converter.convertApaUnicode(
                    this.props.translations,
                    'registro_aceptar',
                    'Aceptar',
                  )}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  translations: state.translations,
});

const mapDispatchToProps = dispatch => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalErrorResetPassword);
